var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewAllIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.5,
    height: 21,
    viewBox: "0 0 28.5 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01ced1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#14b1e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2992fb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-view-comfy",
    "data-name": "Icon material-view-comfy",
    d: "M4.5,13.5h6v-6h-6Zm0,7.5h6V15h-6ZM12,21h6V15H12Zm7.5,0h6V15h-6ZM12,13.5h6v-6H12Zm7.5-6v6h6v-6ZM27,21h6V15H27ZM4.5,28.5h6v-6h-6Zm7.5,0h6v-6H12Zm7.5,0h6v-6h-6Zm7.5,0h6v-6H27Zm0-21v6h6v-6Z",
    transform: "translate(-4.5 -7.5)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllIcon);
export default __webpack_public_path__ + "static/media/view-all-icon.96d8c7ab9d0f625c40b299a44c7c9dfb.svg";
export { ForwardRef as ReactComponent };